import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Toggle from './Toggle';

const ToggleRow = ({ label, description, value, onValueChange, disabled = false, testID }) => {
    return (
        <View style={styles.container}>
            <View style={styles.row}>
                <View style={styles.labelContainer}>
                    <Text style={styles.label}>{label}</Text>
                    {description && <Text style={styles.description}>{description}</Text>}
                </View>
                <Toggle
                    disabled={disabled}
                    accessibilityLabel={label}
                    onValueChange={onValueChange}
                    value={value}
                    testID={testID}
                />
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    container: {
        marginVertical: spacing.xs + 2,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 10,
        paddingVertical: 5,
        paddingHorizontal: 8,
        gap: 12,
    },
    labelContainer: {
        flex: 1,
    },
    label: {
        color: colors.text,
        fontSize: typography.body,
        fontFamily: fonts.heading,
    },
    description: {
        fontSize: typography.caption,
        lineHeight: 17,
        color: colors.textTertiary,
        paddingTop: 4,
    },
}));

export default React.memo(ToggleRow);
